<mat-card class="geofence-config-card">
  <mat-toolbar class="toolbar-subtitle">
    <mat-toolbar-row>Geolocation Check-in Access configuration</mat-toolbar-row>
  </mat-toolbar>
  <mat-card-content>
    <mat-form-field class="form-column geofence-form-column">
      <mat-label>Check-in radius (geofence)</mat-label>
      <input
        matInput
        placeholder="Check-in radius (geofence)"
        [ngModel]="geofence"
        (ngModelChange)="onGeofenceChange($event)"
        name="geofence"
        type="number"
        min="1" />
    </mat-form-field>
    <div class="geofence-content-paragraph">
      The radius helps you define the zone around the gym where the user can
      check in. By default, its value is 500m. Please enter a value in meters
      greater than 0.
    </div>
  </mat-card-content>
</mat-card>
